module.exports = __webpack_public_path__ + "img/102.bad657bb.jpg";